import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import jaJP from 'antd/locale/ja_JP';
import 'antd/dist/reset.css';
import Dashboard from './components/Dashboard';
import DashboardV2 from './components/DashboardV2';
import FullscreenProUsers from './components/FullscreenProUsers';
import FullscreenNewUsers from './components/FullscreenNewUsers';
import FullscreenAlertUsers from './components/FullscreenAlertUsers';
import FullscreenFreeUsers5Patients from './components/FullscreenFreeUsers5Patients';
import LoginPage from './components/LoginPage';
import AuthGate from './components/AuthGate';
import './App.css';

function App() {
  return (
    <ConfigProvider locale={jaJP}>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<AuthGate><Dashboard /></AuthGate>} />
            <Route path="/legacy" element={<AuthGate><Dashboard /></AuthGate>} />
            <Route path="/insights" element={<AuthGate><DashboardV2 /></AuthGate>} />
            <Route path="/deep" element={<AuthGate><DashboardV2 /></AuthGate>} />
            <Route path="/fullscreen/pro-users" element={<AuthGate><FullscreenProUsers /></AuthGate>} />
            <Route path="/fullscreen/new-users" element={<AuthGate><FullscreenNewUsers /></AuthGate>} />
            <Route path="/fullscreen/alert-users" element={<AuthGate><FullscreenAlertUsers /></AuthGate>} />
            <Route path="/fullscreen/free-users-5-patients" element={<AuthGate><FullscreenFreeUsers5Patients /></AuthGate>} />
          </Routes>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
